import React from "react";

interface IGlobalSharingBodyComponent {
	readonly viewActionType: ViewActionType;
	readonly isReports: boolean;
	readonly globalItemNames: string[];
	readonly allItemNames: string[];
	readonly itemCount: number;
}

type ViewActionType = "makePrivate" | "makeGlobal" | "modify" | "delete" | "rename" | "create";

export const GlobalSharingBodyComponent = (props: IGlobalSharingBodyComponent) => {
	const {viewActionType, isReports, globalItemNames, allItemNames, itemCount} = props;
	const itemType = isReports ? "report" : "view";
	let message: React.JSX.Element;

	switch (viewActionType) {
		case "delete":
			message = isReports ? (
				<>
					This action will delete the following global report(s) for all users with access: <b>{globalItemNames.join(", ")}</b>. Are you sure you want
					to delete the selected {itemCount} item(s)?
				</>
			) : (
				<>This action will delete the {itemType} for all users who have access.</>
			);
			break;
		case "modify":
		case "rename":
			message = isReports ? (
				<>Any changes you make to this report will affect all users it is shared with.</>
			) : (
				<>Changes you make are visible to all users who have access.</>
			);
			break;
		case "makePrivate":
			message = isReports ? (
				<>
					This will make the <b>{allItemNames[0]}</b> private and only visible to you.
				</>
			) : (
				<>This action will remove access to the {itemType} for all users. It will be available under My Views.</>
			);
			break;
		case "makeGlobal":
			message = isReports ? (
				<>
					<b>{allItemNames[0]}</b> will be shared with all users in the organization, and only administrators will have permission to edit it.
				</>
			) : (
				<>
					Global {itemType}s are shared with all users in the organization. Administrators will have edit permissions. It will be available under
					Global.
				</>
			);
			break;
		case "create":
			message = (
				<>This {itemType} will be shared with all administrators in your organization as well as “All Users” group. Do you wish to continue?</>
			);
			break;
		default:
			message = <></>;
			break;
	}

	return <span>{message}</span>;
};
